import { createBrowserHistory, createHashHistory } from 'history'
import platform from 'utils/platform'

//browserHistory makes it easier/cleaner to navigate on desktop, and hashHistory makes it easier to manipulate on native, in case we need to refresh/navigate back, since it might not have the perfect URL since it's not loading from our server, but with some local webview shenanigan
const defaults = { basename: process.env.REACT_APP_BASE_PATH }
const history  = (platform.isNative()? createHashHistory : createBrowserHistory)(defaults)

//React components should use `const history = useHistory()` instead :))
export default history
